<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Logs do Utilitário Desktop</strong>
        </div>
        <b-form @submit.stop.prevent>
          <b-form-group label="CPF / CNPJ" label-for="cpf-cnpj">
            <b-form-input id="cpf-cnpj" placeholder="Ex: 12345678901" v-model="clientId"></b-form-input>
          </b-form-group>
          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="success" @click="find"><i class="fa fa-search"></i> Buscar</b-button>
              </b-col>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="info" @click="clean">Limpar</b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
        <b-row>
          <b-col v-show="files != null || files != undefined" style="padding-top: 15px">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Nome do arquivo</th>
                  <th scope="col">Visualizar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="file.file" v-for="(file, index) in files">
                  <th scope="row">{{index}}</th>
                  <td>{{file.file}}</td>
                  <td>  
                    <button class="btn btn-primary" @click="viewLog(index)">Visualizar</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import { request } from 'http';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      clientId: null,
      loadCount: 0,
      files: []
    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  mounted() {
    this.files = this.$route.params.files;
    console.log(this.files);
  },
  methods: {
    clean () {
      const self = this;

      self.files = null;
      self.clientId = '';
    },
    viewLog(id) {
      const self = this;
      
      console.log(self.files);
      self.$router.push({
        name: 'Log do utilitário',
        params: {
          file: self.files[id],
          files: self.files
        }
      });
    },
    find() {
      var self = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/logs-utility/${self.clientId}`)
        .then(function(response) {
            self.files = response.data.files;
            console.log(self.files);
        })
        .catch(function(error) {

          requestError(error);
        })
        .finally(() => {
          self.loadCount--;
        });
    }
  }
}
</script>
